import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import IconCard1 from "../../images/icon_card_20.png";
import IconCard2 from "../../images/icon_card_18.png";
import IconCard3 from "../../images/icon_card_17.png";
import IconCard4 from "../../images/icon_card_15.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS2 = () => {
  const solutions = [
    {
      title: "Struggling with Lead Generation & Property Visibility?",
      problem:
        "Low website traffic, fewer inquiries, and properties not reaching potential buyers.",
      solution:
        "We design SEO-optimized real estate portals with IDX/MLS integration and targeted PPC campaigns to drive high-intent buyers to your listings.",
    },
    {
      title: "Facing Poor User Experience & Mobile Compatibility Issues?",
      problem:
        "Unresponsive design, slow property searches, and poor navigation leading to user drop-offs.",
      solution:
        "We build mobile-friendly, high-performance websites with intuitive property search filters, virtual tours, and fast-loading pages for seamless browsing.",
    },
    {
      title: "Lacking an Effective Social Media Presence?",
      problem:
        "Weak brand awareness, low engagement, and ineffective social media marketing efforts.",
      solution:
        "We provide social media branding, ad campaigns, and influencer marketing to enhance your online presence and attract potential buyers.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "HIPAA-compliant medical websites with secure patient portals",
        "Telemedicine platform development & integrations",
        "Online appointment scheduling & automated reminders",
        "EHR/EMR integration for seamless data management",
        "AI-powered chatbots for instant patient assistance",
      ],
      image: require("../../images/web-development-1.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "Local SEO to rank higher in medical searches.",
        "PPC & Google Ads for instant appointment bookings.",
        "Content marketing & medical blogging to educate.",
        "Social media management & ad campaigns for patient engagement.",
        "Reputation management & online reviews optimization.",
      ],
      image: require("../../images/digital-marketing-1.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    { title: "Patient Portal UI Mockups", icon: IconCard1 },
    { title: "Telemedicine Platform Analytics", icon: IconCard2 },
    { title: "Medical SEO Performance Insights", icon: IconCard3 },
    { title: "Secure Healthcare Web Designs", icon: IconCard4 },
  ];

  const caseStudyData = {
    sectionTitle: "Real Results for Healthcare Businesses",
    sectionSubtitle:
      "Our telemedicine platform boosted patient appointments by 70% in just 4 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Elevate Your Healthcare Business",
    description:
      "Empower your healthcare practice with cutting-edge digital solutions that enhance efficiency, security, and patient care.",
    buttonText: "Schedule a Strategy Call Today",
    image: require("../../images/health.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay informed with the latest healthcare digital trends, best practices, and success strategies.Explore expert insights:";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Transforming Healthcare with Smart Digital Solutions"}
          pageSub={
            "Secure, compliant, and patient-focused digital solutions to enhance healthcare accessibility, streamline operations, and improve patient engagement."
          }
          backgroundImage={require("../../images/web-3.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Craft Your Web-Based Software"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="flex-end"
          justifyContent="flex-start"
          textAlign="left"
          boxAlign="flex-start"
          titleColor="#000"
          descriptionColor="#000"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS2;
